<template>
  <div class="myt-dashboard-page">
    <div :class="step != 5 && step != 6 ? 'left-panel' : 'full-panel'">
      <v-stepper v-model="step" alt-labels class="no-transition">
        <v-stepper-header class="stepper-header">
          <v-stepper-step @click="step = 1" :complete="step > 1" :step="1">Target Exam</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step @click="step = step > 1 ? 2 : step" :complete="step > 2" :step="2">Subjects</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step @click="step = step > 2 ? 3 : step" :complete="step > 3" :step="3">Difficulty</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step @click="step = step > 3 ? 4 : step" :complete="step > 4" :step="4">Pattern</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="5" :class="{ 'stepper-active-span v-stepper__step--active': step === 6 }">Syllabus</v-stepper-step>
          <div v-if="innerWidth<991" class="v-stepper__label-custom"> {{stepTitle}}</div>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" :style="{ height: divHeight + 'px' }">
            <div class="outer-hg-100" v-if="step === 1">
              <StepOneData :data="stepOneData" :onNextClick="onStepOneNextClick" :testCount="testCount" />
            </div>
          </v-stepper-content>
          <v-stepper-content step="2" :style="{ height: divHeight + 'px' }">
            <div class="outer-hg-100" v-if="step === 2">
              <StepTwoData 
                :data="stepTwoData" 
                :stepOneData="stepOneData" 
                :items="subjects"
                :onCustomizeClick="onCustomizeStepFourClick" 
                :onNextClick="onStepFourNextClick"
                :onClickPattern="onClickPattern" 
                :onCLickSubject="onCLickSubject"
                :onClickDifficultyLevel="onClickDifficultyLevel" 
                :step="step"
                :patternData="patternData"
              />
            </div>
          </v-stepper-content>
          <v-stepper-content step="3" :style="{ height: divHeight + 'px' }">
            <div class="outer-hg-100" v-if="step === 3">
              <StepTwoData 
                :data="stepTwoData" 
                :stepOneData="stepOneData" 
                :items="subjects"
                :onCustomizeClick="onCustomizeStepFourClick" 
                :onNextClick="onStepFourNextClick"
                :onClickPattern="onClickPattern" 
                :onCLickSubject="onCLickSubject"
                :onClickDifficultyLevel="onClickDifficultyLevel"
                :step="step"
                :patternData="patternData"
              />
            </div>
          </v-stepper-content>
          <v-stepper-content step="4" :style="{ height: divHeight + 'px' }">
            <div class="outer-hg-100" v-if="step === 4">
              <StepTwoData 
                :data="stepTwoData" 
                :stepOneData="stepOneData" 
                :items="subjects"
                :onCustomizeClick="onCustomizeStepFourClick" 
                :onNextClick="onStepFourNextClick"
                :onClickPattern="onClickPattern" 
                :onCLickSubject="onCLickSubject"
                :onClickDifficultyLevel="onClickDifficultyLevel" 
                :step="step"
                :patternData="patternData"
              />
            </div>
          </v-stepper-content>
          <!-- <v-stepper-content step="5"> -->
          <div class="outer-hg-100" v-if="step === 5">
            <StepFiveData 
              :data="stepFiveData" 
              :stepOneData="stepOneData" 
              :stepTwoData="stepTwoData"
              :stepThreeData="stepThreeData" 
              :stepFourData="stepFourData" 
              :questionType="questionTypes2"
              :questionTypes2="questionTypes" 
              :onNextClick="onStepFiveNextClick"
              :onCustomizeClick="onCustomizeStepFiveClick" 
              :clearData="clearData" 
              :onBackClick="onBackClick" 
              :patternData="patternData"
            />
          </div>
          <!-- </v-stepper-content> -->
          <div class="outer-hg-100" v-if="step === 6">
            <MYTPattern 
              :data="stepFiveData" 
              :stepOneData="stepOneData" 
              :stepTwoData="stepTwoData"
              :stepThreeData="stepThreeData" 
              :stepFourData="stepFourData" 
              :onNextClick="onStepFiveNextClick"
              :questionType="questionTypes" 
              :clearData="clearData" 
              :onCustomizeClick="onCustomizeStepFiveClick" />
          </div>
        </v-stepper-items>
      </v-stepper>
    </div>
    <div class="right-panel" v-if="step != 6 && step != 5">
      <div class="panel-header">WHAT YOU GET</div>
      <div class="panel-body">
        <div class="panel-text-row">
            <div class="panel-text-title">JEE / NEET Pattern Tests Of Any Syllabus</div>
          <div class="panel-text-text">
            Make tests of the latest <b class="content-bld">JEE or NEET Pattern</b> of any subject in less than 1 minute. Get creative and make a <b class="content-bld">Custom Pattern test.</b>
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title">Flexibility To Choose Subtopic Wise Questions</div>
          <div class="panel-text-text">
            Want to <b class="content-bld">make a test</b> without completing the entire chapter? Worry not! Select specific <b class="content-bld">subtopics</b> of a chapter and make a test from it.
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title">Save Time By Leveraging Technology</div>
          <div class="panel-text-text">
            <b class="content-bld">Generate a test</b> in less than 60 secs. Let technology work for you to help you save time, while making tests without any repetition of questions.
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title number-counter" v-if="questionCount">Ability To Replace Question From Pool Of <number ref="number1" :from="questionCount-50" :to="questionCount" :duration="5" :delay="0" easing="Power1.easeOut"/> Questions
          </div>

          <div class="panel-text-title number-counter" v-else> Ability To Replace Question From Pool Of<span> 0 </span>Questions
          </div>
          <div class="panel-text-text">
            Don’t like a question in the <b class="content-bld">auto-generated tests</b>? Replace the question from our ever increasing database.Easy!
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title">Your Branding In Header & Footer</div>
          <div class="panel-text-text">
            Make <b class="content-bld">high-quality professional looking tests</b> with your own branding. Upload header/footer images and see the magic unfold.
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title">Separate PDFs For Test & Solution</div>
          <div class="panel-text-text">
            Choose from 4 different varieties of templates for <b class="content-bld">test PDF. Detailed solutions</b> can be downloaded as a separate PDF.
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title">Make 10 Tests And Download 1 Test For Free</div>
          <div class="panel-text-text">
            Make up to 10 tests and check the <b class="content-bld">quality, accuracy and relevance.</b> Download the PDFs of the first test for free.
             Pay only if you are satisfied with the quality.
          </div>
        </div>
        <div class="panel-text-row">
          <div class="panel-text-title">Error-Free And Relevant Questions</div>
          <div class="panel-text-text">
            An <b class="content-bld">in-house team of IITians and Ph.Ds.</b> with decades of teaching experience are continuously working on enhancing the database for you.
             In case of any oversight from our side, you can “Report Error” and we will rectify is ASAP.
          </div>
        </div>
      </div>
    </div>
    <AlertBox :width="modalwidth" :onClose="onCloseAlertBox" :component="cComponent" :status="open"
            :data="customErrorMsg" />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
import StepOneData from "./components/StepOneData.vue";
import StepTwoData from "./components/StepTwoData.vue";
import StepThreeData from "./components/StepThreeData.vue";
import StepFourData from "./components/StepFourData.vue";
import StepFiveData from "./components/StepFiveData.vue";
import moment from "moment";
import MYTPattern from "./components/MYTPattern.vue";

export default {
  name: "MYTDashboard",
  data() {
    return {
      e1: 1,
      step: 1,
      subjects: [],
      difficultyLevels: constants.DIFFICULTY_LEVELS,
      testName: "",
      targetExam: [],
      selectedSubjects: [],
      stepOneData: null,
      stepTwoData: null,
      stepThreeData: null,
      stepFourData: null,
      stepFiveData: null,
      questionTypes: {},
      questionTypes2: [],
      questionCount: null,
      testCount: null,
      innerWidth:"",
      elemHeight:null,
      patternData:{},
      subjectChapterId: {},
      customErrorMsg:"",
      cComponent:"",
      modalwidth:"500px",
      open:false
    };
  },
  destroyed(){
    window.removeEventListener("resize", this.updateDivHeight);
  },
  created(){
    window.addEventListener("resize", this.updateDivHeight);
  },
  mounted() {
    this.innerWidth=window.innerWidth;
    this.checkTestLimit();
    this.requestGetRefData();
    this.getAllQuestionCount();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  computed:{
    ...mapState("userStore", ["user"]),
    stepTitle(){
      if(this.step==1){
        return "Target Exam"
      }
      else if(this.step==2){
        return "Subjects"
      }
      else if(this.step==3){
        return "Difficulty"
      }
      else if(this.step==4){
        return "Pattern"
      }
      else if(this.step==5|| this.step==6){
        return "Syllabus"
      }
      else{
        return ""
      }
    },
    divHeight(){
      this.updateDivHeight();
     return this.elemHeight 
    },
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getMYTTestPatterns: "utilStore/getMYTTestPatterns",
      createCustomTestAPI: "testStore/createCustomTest",
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic",
      createMytTest: "testStore/createMytTest",
      getMYTRefData: "utilStore/getMYTRefData",
      getAllQuestionsCount: "utilStore/getAllQuestionsCount",
      testCreationLimit: "testStore/testCreationLimit"
    }),
    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"],myt_institute: true};
      this.getMYTRefData(reqData)
        .then((response) => {
          this.loading = false;
          this.questionTypes = response.QUESTION_TYPE.map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
          this.questionTypes2 = response.QUESTION_TYPE.filter(
            (xx) =>
              xx.id != 14 &&
              xx.id != 15 &&
              xx.id != 16 &&
              xx.id != 17 &&
              xx.id != 18 &&
              xx.id != 20 &&
              xx.id != 21 &&
              xx.id != 23 &&
              xx.id != 24 &&
              xx.id != 8
          ).map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getChaptersForAllSubjects() {
      let subjectIds = this.stepTwoData.selectedSubjects.map((subject) =>
        this.getSubjectId(subject.value)
      );
      let reqData = {
        level: 3,
        parent_ids: subjectIds
      };
      this.$root.showLoader = true;

      this.getDataTreeWithLevelPublic(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.stepTwoData.selectedSubjects.map((subject) => {
            let sub = response.find(
              (s) =>
                s.parent == subject.value.id ||
                s.sub_subject === subject.value.code
            );
            this.subjectChapterId[subject.value.id] = {
              chapterId: sub.id
            };
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    updateDivHeight(){
      if (window.innerWidth > constants.MOBILE_MAX_WIDTH) {
        this.$nextTick(() => {
          if(window.innerHeight < 715){
            this.elemHeight=  (window.innerHeight/1.31).toFixed(2);
          }
          else if(window.innerHeight < 790){
            this.elemHeight=  (window.innerHeight/1.30).toFixed(2);
          }
          else{
            this.elemHeight=  (window.innerHeight/1.29).toFixed(2);
          }
         });
      }
    },
    onStepOneNextClick(data) {
      this.stepOneData = {
        ...data,
        targetSelected: data.targets.find(
          (t) => t.value === data.selectedTarget
        )
      };
      this.targetExam = data.targetExam;
      this.testName = data.testName;
      if (data.isTargetChanged) {
        this.stepTwoData = {};
        this.stepThreeData = {};
        this.stepFourData = {};
        this.stepFiveData = {};
      }
      if (data.testName && data.selectedTarget) {
        this.step = 2;
      } else if (!data.testName) {
        this.$toasted.error(`Please enter test name`);
      } else if (!data.selectedTarget) {
        this.$toasted.error(`Please select target exam`);
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    onStepTwoNextClick(data) {
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      if (
        data.stepTwoData.selectedSubjectWithDifficultyLevel &&
        data.stepTwoData.selectedSubjectWithDifficultyLevel.length === 0
      ) {
        this.$toasted.error(`Please select subject`);
      } else if (
        data.stepTwoData &&
        data.stepTwoData.selectedSubjectWithDifficultyLevel &&
        data.stepTwoData.selectedSubjectWithDifficultyLevel.length
      ) {
        this.step = 3;
      }
    },
    onStepThreeNextClick(data) {
      this.stepThreeData = data.stepThreeData;
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      if (
        data.stepThreeData.selectedSubjects &&
        data.stepThreeData.selectedSubjects.length
      ) {
        let valid = true;
        data.stepThreeData.selectedSubjects.map((s) => {
          if (!s.difficulty) {
            this.$toasted.error(
              `Please select difficulty level for ${s.text}`,
              { icon: "info" }
            );
            valid = false;
          }
        });
        if (valid) {
          this.step = 4;
        }
      }
    },
    onStepFourNextClick(data) {
      this.stepFourData = data.stepFourData;
      this.stepThreeData = data.stepThreeData;
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      if (
        data.stepTwoData.selectedSubjectWithDifficultyLevel &&
        data.stepTwoData.selectedSubjectWithDifficultyLevel.length === 0
      ) {
        this.$toasted.error(`Please select subject`);
      } else if (
        data.stepTwoData.selectedSubjects &&
        data.stepTwoData.selectedSubjects.length
      ) {
        let valid = true;
        data.stepTwoData.selectedSubjects.map((s) => {
          if (!s.difficulty) {
            this.$toasted.error(
              `Please select difficulty level for ${s.text}`,
              { icon: "info" }
            );
            valid = false;
          }
        });
      }
      if (!data.stepTwoData.selectedPatterns) {
        this.$toasted.error(`Please select pattern`);
      } else if (
        data.stepTwoData.customize &&
        !isNaN(data.stepTwoData.selectedPatterns.id)
      ) {
        this.processTestData(data);
        this.step = 5;
      } else {
        this.processTestData(data);
      }
    },
    onCustomizeStepFourClick(data) {
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      if (
        data.stepTwoData.selectedSubjectWithDifficultyLevel &&
        data.stepTwoData.selectedSubjectWithDifficultyLevel.length === 0
      ) {
        this.$toasted.error(`Please select subject`);
      } else if (
        data.stepTwoData.selectedSubjects &&
        data.stepTwoData.selectedSubjects.length
      ) {
        let valid = true;
        data.stepTwoData.selectedSubjects.map((s) => {
          if (!s.difficulty) {
            this.$toasted.error(
              `Please select difficulty level for ${s.text}`,
              { icon: "info" }
            );
            valid = false;
          }
        });
      }
      if (!data.stepTwoData.selectedPatterns) {
        this.$toasted.error(`Please select pattern`);
      } else if (
        data.stepTwoData.customize
      ) {
        this.processTestData(data);
        // this.step = 6;
      } else {
        if (this.validate(data)) {
          this.step = 5;
        }
      }
    },
    onCustomizeStepFiveClick(data) {
      // this.stepFourData = data.stepFourData;
      // this.stepThreeData = data.stepThreeData;
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      this.stepFiveData = data;
      this.step = 6;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    processTestData(data, nextPage) {
      let selectedSubjects = this.stepTwoData.selectedSubjects;
      let selectedPatterns = this.stepTwoData.selectedPatterns;
      // this.duration = 0;
      let chapterId = 0,
        questions = [],
        questionNo = 0,
        subIndex = 0,
        optionalQuestionsList = [];
      if (this.validate({stepTwoData:this.stepTwoData,stepOneData:this.stepOneData})) {
        // // this.duration = this.selectedPatterns.test_params[0].duration;
        selectedSubjects.map((s) => {
          let currentSubjectId =
            selectedSubjects && selectedSubjects.length
              ? this.getSubjectId(selectedSubjects[0].value)
              : 0;
              chapterId = this.subjectChapterId[s.value.id]
                ? this.subjectChapterId[s.value.id].chapterId
                : 0;
          let sub_subject;
          selectedPatterns.test_params.map((p, index) => {
            if (
              p.question_type_id != this.QUE_TYPES.COMPREHENSION &&
              p.question_type_id != this.QUE_TYPES.TC &&
              p.optional_question &&
              parseInt(p.optional_question.no_of_mandatory_questions) <
              parseInt(p.optional_question.number_of_question) &&
              p.subject_ids.includes(currentSubjectId)
            ) {
              let queData = selectedPatterns.test_params[index];
              let newQueData = optionalQuestionsList.findIndex(
                (c) =>
                  c &&
                  c.questionType === queData.question_type_id &&
                  c.subject === this.getSubjectId(s.value)
              );
              let newMandatoryQueObj = {};
                newMandatoryQueObj = {
                  noOfMandatoryQuestions: parseInt(
                    p.optional_question.no_of_mandatory_questions
                  ),
                  allowAll: parseInt(p.optional_question.allow_all),
                  numberOfQuestions: parseInt(
                    p.optional_question.number_of_question
                  ),
                  mandatoryQuestionId: null,
                  questionType: p.question_type_id,
                  subType: p.question_subType_id,
                  subject: this.getSubjectId(s.value),
                  sub_subject: s && s.value.code ? s.value.code : "null"
                };
                optionalQuestionsList.push(newMandatoryQueObj);
              }
            if (currentSubjectId != s.value.id && !this.checkBiology(s.value)) {
              currentSubjectId = this.getSubjectId(s.value);
              // this.duration += p.duration;
              ++subIndex;
            } else if (
              this.checkBiology(s.value) &&
              sub_subject !== s.value.code
            ) {
              sub_subject = s.value.code;
              ++subIndex;
            }
            if (
              p.subject_ids.includes(this.getSubjectId(s.value)) ||
              (selectedPatterns.id === 15 &&
                ((p.subject_ids[0].length &&
                  p.subject_ids[0].includes(this.getSubjectId(s.value))) ||
                  (p.subject_ids[1].length &&
                    p.subject_ids[1].includes(this.getSubjectId(s.value))) ||
                  (p.subject_ids[2].length &&
                    p.subject_ids[2].includes(this.getSubjectId(s.value))) ||
                  (selectedSubjects.length === 1 &&
                    p.subject_ids[2].includes(this.getSubjectId(s.value)))))
            ) {
              let currentQuestion = {
                index: questionNo,
                subIndex: subIndex,
                subject: { ...s.value, difficulty: s.difficulty },
                selectedSubType: p.question_subType_id,
                question_text: this.DUMMYTEXT,
                solution: this.DUMMYTEXT,
                correct_answer: null,
                options: [],
                options_abc: [],
                options_pqr: [],
                chapterId:chapterId,
                hints: [{ text: this.DUMMYTEXT }],
                questions: [],
                startValue: null,
                endValue: null,
                questionType: p.question_type_id,
                subtype: p.question_subType_id,
                correctMarkingSchema: this.patternData.positive_marks ? this.patternData.positive_marks : 1,
                inCorrectMarkingSchema: this.patternData.negative_marks ? this.patternData.negative_marks : 0,
                partialMarking: p.partial_marking,
                required_questions: parseInt(p.number_of_question)
              };
              // currentQuestion = this.setDummyAnswerAsPerType(currentQuestion);
              questions.push(currentQuestion);
              questionNo++;
            }
          });
        });
        let questionList = questions;  //removing getQuestionArray(questions)
        if (this.stepTwoData.customize) {
          this.stepFiveData = { data: { questionList, optionalQuestionsList } };
          this.step = 6;
        } else {
          this.createCustomTest(questionList, optionalQuestionsList, nextPage);
        }
      }
    },
    validate(data) {
      let subject_ids = [];
      if (
        !data ||
        !data.stepOneData.testName ||
        data.stepOneData.testName.trim().length === 0
      ) {
        this.$toasted.error(`Please enter test name`, { icon: "info" });
        return false;
      } else if (
        data &&
        data.stepOneData.testName &&
        data.stepOneData.testName.trim().length > 50
      ) {
        this.$toasted.error(
          `Test Name should not contain more than 50 characters`,
          { icon: "info" }
        );
        return false;
      } else if (
        !data.stepOneData.targetSelected ||
        data.stepOneData.targetSelected.length === 0
      ) {
        this.$toasted.error(`Please select exam target`, {
          icon: "info"
        });
        return false;
      } else if (!data.stepTwoData.selectedPatterns) {
        this.$toasted.error(`Please select exam pattern`, {
          icon: "info"
        });
        return false;
      } else if (
        !data.stepTwoData.selectedSubjects ||
        data.stepTwoData.selectedSubjects.length === 0
      ) {
        this.$toasted.error(`Please select subject`, { icon: "info" });
        return false;
      } else if (
        data.stepTwoData.selectedSubjects &&
        data.stepTwoData.selectedSubjects.length
      ) {
        let subjectIds = [];
        let valid = true;

        data.stepTwoData.selectedSubjects.map((s) => {
          if (!s.difficulty) {
            this.$toasted.error(
              `Please select difficulty level for ${s.text}`,
              { icon: "info" }
            );
            valid = false;
          }
        });
        if (!valid) {
          return false;
        }
      }
      return true;
    },
    createCustomTest(questions, optionalQuestionsList, confirmation) {
      let myInstitute = JSON.parse(localStorage.getItem("myInstitute"));
      let creatorId = localStorage.getItem('guest_user_id');
      let userData = JSON.parse(sessionStorage.getItem('user'))
      let stepOneData = this.stepOneData;
      let questionTypes = this.questionTypes2;
      this.$root.showLoader = true;
      let isOnline = localStorage.getItem("isOnlineTest");
      let { list, forUpdate } = this.createTestData(
        { questions, optionalQuestionsList },
        confirmation,
        true
      );
      let reqData = {
        list: list,
        target_exam: stepOneData.targetSelected.target_exam_id,
        test_type: stepOneData.testType
          ? stepOneData.testType
          : this.TEST_TYPE.CUSTOM,
        duration: stepOneData.duration,
        test_name: stepOneData.testName,
        optionalQuestionsList: optionalQuestionsList,
        is_online_test: isOnline === "Online" ? 1 : 0,
        // institute_id: myInstitute.id,
        institute_id: myInstitute.id,
        creator_id: userData ? userData.id.toString() : creatorId
      };
      if (confirmation) {
        reqData.allowed_dummy_question = true;
      }
      this.createMytTest(reqData)
        .then((response) => {
          this.loading = false;
          let subjectCustomMsg = [];
          if (response.code === 204) {
            this.$root.showLoader = true;
            response.list.map((s) => {
              subjectCustomMsg.push(
                `${s.required_dummy_questions} questions of ${s.sub_type
                  ? questionTypes.find((q) => q.value.id === s.sub_type).text
                  : questionTypes.find(
                    (q) => q.value.id === s.question_type_id
                  ).text
                } from ${this.stepTwoData.selectedSubjects.find(
                  (sub) =>
                    sub.value.id === s.subject_id || sub.value.code === s.sub_subject
                ).title
                }`
              );
              // subjectCustomMsg.push(`${s.required_questions} questions requested for ${stepOneData.selectedSubjects.find(sub=> sub.id === s.subject_id).title} subject with question type ${questionTypes.find(q=>q.value.id === s.question_type_id).text} only ${s.available} are available`)
            });
            // subjectCustomMsg = subjectCustomMsg.join(",\n")
            this.customErrorMsg = subjectCustomMsg;
            // this.customErrorMsg= "Out of " + subjectCustomMsg + ". Do you want to change the parameters OR keep those questions dummy and edit them manually?"
            this.cComponent =
              "components/coordinator/Tests/CustomizedTests/customizedTestAlertBox";
            this.modalwidth = "525px";
            this.open = true;
            this.$forceUpdate();
          } else {
            this.$root.showLoader = false;

            this.$toasted.success(`Success\n${response.msg}`, {
              icon: "check_circle"
            });
            this.clearData();
          }
          this.disableCreateTest = false;

          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
          this.disableCreateTest = false;
        });
    },
    onCloseAlertBox(data) {
      this.open = data.status;
      this.disableCreateTest = false;
      if (data.confirm) {
        this.processTestData(true, data.confirm);
      }
    },
    clearData(data) {
      this.$router.push({ name: "my-tests" });
      this.step = 1;
      this.stepOneData = {};
      this.stepTwoData = {};
      this.stepThreeData = {};
      this.stepFourData = {};
      this.stepFiveData = {};
    },
    onBackClick(data) {
      this.stepFiveData = data;
      this.step = this.step - 1;
    },
    getAllQuestionCount() {
      this.getAllQuestionsCount({ mytUser: true })
        .then((response) => {
          this.questionCount = response
        })
        .catch((err) => {
          console.log(err);
        })
    },
    isAllDifficultySelected() {
      let valid = false;
      if (this.stepTwoData && this.stepTwoData.selectedSubjectWithDifficultyLevel && this.stepTwoData.selectedSubjectWithDifficultyLevel.length) {
        valid = true
        this.stepTwoData.selectedSubjectWithDifficultyLevel.map(s => {
          if (!s.difficulty) {
            valid = false
          }
        })
        if (valid) {
          this.step = 3
        }
      }
      return valid;
    },

    onClickDifficultyLevel(data) {
      this.step = 3
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      delete this.stepTwoData.targetSelected
      delete this.stepTwoData.selectedPatterns
    },
    onClickPattern(data) {
      console.log("patttern");
      if(this.step!=4){
        this.getChaptersForAllSubjects();
      }
      this.step = 4
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
    },
    onCLickSubject(data) {
      this.step = 2
      this.stepTwoData = data.stepTwoData;
      this.stepOneData = data.stepOneData;
      delete this.stepTwoData.targetSelected
      delete this.stepTwoData.selectedPatterns
    },
    
        completed() {
            console.log('Animation ends!');
        },
        playAnimation() {
            this.$refs.number2.play()
        },
        checkTestLimit(){
          let creatorId = localStorage.getItem('guest_user_id');
          if (!creatorId) {
            creatorId = 'temp'+moment().format('X')
            localStorage.setItem('guest_user_id',creatorId)
          }
          let userData = this.user;
          let reqData= {
            creator_id: userData ? userData.id.toString() : creatorId
          }
          this.testCreationLimit(reqData)
          .then((response) => {
            this.testCount = response.remaining_unpaid_test;
          })
          .catch((err) => {
            console.log(err);
            this.testCount =0;
          })
        }

  },
  components: {
    StepOneData,
    StepTwoData,
    StepThreeData,
    StepFourData,
    StepFiveData,
    MYTPattern
  },
  watch: {
    user(val) {
      this.checkTestLimit()
    }
  }
};
</script>
